import { gql } from "graphql-request";

export const READ_BUSINESS_STRUCTURES = gql`
  query ReadBusinessStructures($tenantId: ID!) {
    readBusinessStructures(tenantId: $tenantId) {
      id
      tenantId
      name
      description
      updatedAt
      nodes {
        id
        businessStructureId
        kind
        playbookId
        label
        notes
        stage
        positionX
        positionY
        playbook {
          id
          name
          objective
        }
      }
      links {
        id
        businessStructureId
        fromNodeId
        toNodeId
        outcomeKey
        label
        isDefault
        sortOrder
      }
    }
  }
`;

export const READ_PLAYBOOKS_FOR_STRUCTURE = gql`
  query ReadPlaybooksForBusinessStructure($tenantId: ID!) {
    readPlaybooks(tenantId: $tenantId) {
      id
      tenantId
      name
      objective
    }
  }
`;
